import useSisenseCourseDropdown from "./UseSisenseCourseDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseCourseDropdown = ({ label, name, value, error, message, onChange }) => {
  const { courseOptions } = useSisenseCourseDropdown();

  return !courseOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={courseOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!courseOptions.options}
      />
    );
};

export default SisenseCourseDropdown;